module.exports = __webpack_public_path__ + "static/media/Space Villain.adbdac04.jpg";